import * as React from "react";
import { createModule } from "../config.js";
import { cssClass, cssVar } from "../utils.js";
const noScroll = cssClass("no_scroll");
const padScrollbar = cssClass("pad_scrollbar");
const scrollbarPadding = cssVar("scrollbar_padding");
export const NoScroll = ({ children }) => {
    React.useEffect(() => {
        const scrollbarWidth = Math.round(window.innerWidth - document.documentElement.clientWidth);
        if (scrollbarWidth > 1) {
            document.body.style.setProperty(scrollbarPadding, `${scrollbarWidth}px`);
            document.body.classList.add(padScrollbar);
        }
        document.body.classList.add(noScroll);
        return () => {
            document.body.style.removeProperty(scrollbarPadding);
            document.body.classList.remove(noScroll, padScrollbar);
        };
    });
    return React.createElement(React.Fragment, null, children);
};
export const NoScrollModule = createModule("no-scroll", NoScroll);
